var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHkLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 110",
    style: {
      enableBackground: "new 0 0 260 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#353A4D;}\n\t.st2{fill:#00D2B7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HomeKeep---Walkthrough"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Login",
    transform: "translate(-65.000000, -104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(65.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185,69.3c-5.4,0-9.5,3.7-10.1,9.7h19.8C194.4,73,190.6,69.3,185,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.6,71.2c-4-0.1-6.9,2.6-7.5,6.9h14.6C135.4,73.8,132.7,71.2,128.6,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,72c-5.1,0-8.7,4-8.7,9.2c0,5.2,3.7,9.3,8.7,9.3c4.9-0.1,8.7-4.1,8.7-9.3C55,76,51.3,72,46.2,72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.3,69.5c-6.3,0-11.1,5.2-11,12.2c0.1,6.8,4.7,11.8,11,11.8c6.3-0.1,10.3-4.8,10.3-12.3 C256.6,74,252.6,69.5,246.3,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.5,69.3c-5.4,0-9.5,3.7-10.1,9.7h19.8C224.9,73,221.1,69.3,215.5,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.7,65.9c-4.1,0-7.7,2.1-10,6c0.1-3,0.1-6,0.1-9.1v-7.1H0v39.5h6.8V81.3c0-5.6,3-9.4,7.5-9.4 c4,0,6,2.2,6,7.6v15.6h6.8V77C27.1,69.9,23.3,65.9,16.7,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.2,65.9c-9.1,0-15.7,6.6-15.7,15.2s6.8,15.2,15.7,15.3c8.9,0,15.6-6.7,15.6-15.3 C61.8,72.5,55.2,65.9,46.2,65.9z M46.2,90.4c-5,0-8.7-4.1-8.7-9.3c0-5.2,3.7-9.2,8.7-9.2S55,76,55,81.2 C55,86.3,51.1,90.3,46.2,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.8,65.9c-4,0-7.9,2.2-10.3,6.8c-1.2-4.4-4.3-6.8-8.9-6.8c-4.1,0-7.2,2.1-9.5,6v-4.8h-6.7v28.1h6.8V81.7 C72.2,76,75,72,79,72c3.5,0,5.5,2.3,5.5,7.7v15.6h6.8V81.7c0-5.7,2.9-9.7,6.8-9.7c3.6,0,5.5,2.3,5.5,7.7v15.6h6.8V77 C110.4,69.9,106.6,65.9,100.8,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.6,65.9c-8.7,0-14.7,6.2-14.7,15.3c0,8.9,5.9,15.2,15,15.2c6,0,10.6-2.7,13.3-7.6l-5.2-2.5l-0.6,0.1 c-1.9,3-4.1,4.5-7.4,4.5c-4.6,0-8.1-3.2-8.1-8.3v-0.3v-0.1h21.7c0.1-0.5,0.1-0.8,0.1-1.2C142.7,71.6,137,65.9,128.6,65.9z  M121.1,78.1c0.6-4.3,3.5-7,7.5-6.9c4.1,0,6.9,2.6,7.2,6.9H121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169,67.6h-4.3l-5.8,5.7c-2.8,2.7-5.6,5.4-8.4,8.1V64.7v-9h-3.2v39.5h3.2v-10l5.2-5l11.4,15h4l-13.2-17 L169,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185,66.4c-8,0-13.7,6-13.7,15c0,8.9,5.6,15,13.9,15c5.5,0,9.8-2.6,12.5-7.3l-2.3-1.6l-0.4,0.1 c-2.4,3.9-5.4,5.8-9.6,5.8c-6,0-10.7-4.3-10.7-11.2v-0.5v-0.1H198c0.1-0.3,0.1-0.5,0.1-0.9C198.1,71.8,192.9,66.4,185,66.4z  M174.8,79.1c0.6-6,4.7-9.7,10.1-9.7c5.6,0,9.5,3.7,9.7,9.7H174.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.5,66.4c-8,0-13.7,6-13.7,15c0,8.9,5.6,15,13.9,15c5.5,0,9.8-2.6,12.5-7.3l-2.3-1.6l-0.4,0.1 c-2.4,3.9-5.4,5.8-9.6,5.8c-6,0-10.7-4.3-10.7-11.2v-0.5v-0.1h23.3c0.1-0.3,0.1-0.5,0.1-0.9C228.6,71.8,223.4,66.4,215.5,66.4z  M205.4,79.1c0.7-6,4.7-9.7,10.1-9.7c5.6,0,9.5,3.7,9.7,9.7H205.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247,66.4c-4.9,0-9.3,2.8-11.5,7.4v-6.2h-3.2V109h3.2V98.4v-9.1c1.8,4.3,6.6,7.2,11.2,7.2 c7.9,0,13.3-6.3,13.3-15.3C260,72.4,254.7,66.4,247,66.4z M246.3,93.4c-6.3,0-10.9-4.9-11-11.8c-0.1-7,4.7-12.2,11-12.2 s10.2,4.5,10.2,11.7C256.6,88.6,252.6,93.4,246.3,93.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "120.5,25.8 139.5,25.8 139.5,25.8 144.6,20.7 144.6,20.7 139.5,15.6 120.5,15.6 120.5,0 110.2,0 110.2,41.4 120.5,41.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "139.5,25.8 139.5,41.4 149.8,41.4 149.8,25.8 144.6,20.7 144.6,20.7 139.5,25.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "149.8,15.6 149.8,0 139.5,0 139.5,15.6 139.5,15.6 144.6,20.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkLogoDark);
export default __webpack_public_path__ + "static/media/hk-logo-dark.6d7c57b8d4e1c2797f82c0079b4af6ea.svg";
export { ForwardRef as ReactComponent };